import { render } from "./ScoreInfoMobile.vue?vue&type=template&id=3aacb50a&scoped=true"
import script from "./ScoreInfoMobile.vue?vue&type=script&lang=js"
export * from "./ScoreInfoMobile.vue?vue&type=script&lang=js"

import "./ScoreInfoMobile.vue?vue&type=style&index=0&id=3aacb50a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aacb50a"]])

export default __exports__